import { Brand, Variant } from './index';

export class Phone {
  id: string;
  name: string;
  brand: Brand;
  variants;

  constructor({brand, id, name, variants}) {
    this.brand = brand;
    this.id = id;
    this.name = name;
    const mapItems = variants.map(v => {
        v.phone = this;
        v.brand = this.brand;
        return [v.id, new Variant(v)];
      });
    this.variants = new Map(mapItems);
    // console.log('variants map', this.variants);
  }

  getVariantByNameId(variantNameId): Variant {
    const variants: Variant[] = <Array<Variant>>Array.from(this.variants.values());
    return variants.find(v => v.nameId === variantNameId);
  }

  getShopUrl(website: string): string {
    let url = '';
    if (website === 'kijiji') {
      url = 'http://www.kijiji.it/elettronica/cellulari-e-accessori/';
      url += `${this.brand.id} ${this.id}`.replace(' ', '+');
    } else if (website === 'subito') {
      url = 'http://www.subito.it/annunci-italia/vendita/telefonia/?q=';
      url += `${this.brand.id} ${this.id}`.replace(' ', '+');
    }
    return url;
  }
}



// WEBPACK FOOTER //
// ./src/app/fonzi-module/models/phone.ts